<template>
  <b-form-input
    :value="value"
    @input="onInput"
    @blur="onBlur"
    :maxlength="maxlength"
    :state="errors.length ? false : null"
    :placeholder="placeholder"
    trim
  />
</template>

<script>
import Mixin from '@/components/mixin/Mixin'

export default {
  mixins: [Mixin],
  props: {
    value: {
      type: String,
      default: null,
    },
    maxlength: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
      required: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onInput($event) {
      // 親コンポーネントに値を伝える
      this.$emit('input', $event)
    },
    onBlur() {
      // 'blur'イベントで変換処理を実行
      this.$emit('input', this.replaceChar(this.value))
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/form/input.vue